import { Box, Stack } from "@mui/material";
import React from "react";
import MainHeader from "../../shared/MainHeader";

const SharedDoc = () => {
  return (
    <Box>
      <MainHeader headingText={"Shared Documents"} />
      <Stack
        gap={3}
        p={4}
        sx={{
          border: "1px solid #C1C1C1",
          minHeight: "80vh",
        }}
      ></Stack>
    </Box>
  );
};

export default SharedDoc;
